module.exports = __webpack_public_path__ + "img/japanese-“bargain”-button.47cc05b6.png";